// extracted by mini-css-extract-plugin
module.exports = {"possessionNoteContainer":"PossessionNote_possessionNoteContainer__1vux5","text":"PossessionNote_text__1PBCM"};